import { render, staticRenderFns } from "./CenterChartPerson.vue?vue&type=template&id=3c256495&scoped=true&"
import script from "./CenterChartPerson.vue?vue&type=script&lang=js&"
export * from "./CenterChartPerson.vue?vue&type=script&lang=js&"
import style0 from "./CenterChartPerson.vue?vue&type=style&index=0&id=3c256495&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c256495",
  null
  
)

export default component.exports